import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./legal.scss";

const Legal = () => {
  const card1Ref = useRef(null);
  const card2Ref = useRef(null);
  const card3Ref = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const cards = [card1Ref.current, card2Ref.current, card3Ref.current];

    const handleMouseMove = (e) => {
      const x = (window.innerWidth / 2 - e.clientX) / 35;
      const y = (window.innerHeight / 2 - e.clientY) / 35;

      cards.forEach((card) => {
        if (card) {
          card.style.transform = `translate(${x}px, ${y}px)`;
        }
      });
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="legal-wrapper">
      {/* VIDEO */}
      <video autoPlay muted loop playsInline className="bg-video">
        <source
          src="https://cdn.coverr.co/videos/coverr-cargo-ship-at-sea-1561431164798?download=1080p"
          type="video/mp4"
        />
      </video>

      <div className="glow glow1"></div>
      <div className="glow glow2"></div>

      {/* NAVBAR */}
      <nav className="navbar">
        <div className="container nav-wrapper">
          <div className="logo">
            MMX <span>HAMID</span>
          </div>

          <div className="nav-links">
            <a href="/">Главная</a>
            <a href="/logistics">Логистика</a>
            <a href="/legal">Юридические услуги</a>
            <a href="/about">О компании</a>
            <a href="/contacts">Контакты</a>
          </div>

          <button className="nav-btn" type="button">
            Консультация
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="bg-text">LEGAL</div>

        <div className="container hero-grid">
          <div className="hero-content" data-aos="fade-right">
            <div className="hero-label">
              ⚖ Международное юридическое сопровождение
            </div>

            <h1 className="hero-title">
              Юридическая защита <span>международной логистики</span>
            </h1>

            <p className="hero-desc">
              MMX HAMID предоставляет комплексное юридическое сопровождение в
              сфере международных перевозок, ВЭД, таможенного оформления и
              защиты интересов бизнеса.
            </p>

            <div className="hero-buttons">
              <button className="btn-primary" type="button">
                Получить консультацию
              </button>

              <button className="btn-secondary" type="button">
                Подробнее
              </button>
            </div>
          </div>

          {/* CARDS */}
          <div className="cards">
            <div className="card card1" data-aos="fade-up" ref={card1Ref}>
              <h3>ВЭД и контракты</h3>
              <p>
                Подготовка и сопровождение международных договоров, контрактов
                поставки и сделок.
              </p>
            </div>

            <div className="card card2" data-aos="fade-left" ref={card2Ref}>
              <h3>Таможенное право</h3>
              <p>
                Сопровождение грузов и помощь в решении таможенных споров.
              </p>
            </div>

            <div className="card card3" data-aos="fade-up" ref={card3Ref}>
              <h3>Международная логистика</h3>
              <p>
                Юридическая защита логистических операций и транспортных
                процессов.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="services">
        <div className="container">
          <h2 className="section-title" data-aos="fade-up">
            Наши услуги
          </h2>

          <div className="services-grid">
            <div className="service-box" data-aos="fade-up">
              <div className="service-icon">📄</div>
              <h3>Контрактное право</h3>
              <p>
                Проверка и составление международных договоров, контрактов и
                соглашений.
              </p>
            </div>

            <div className="service-box" data-aos="fade-up" data-aos-delay="100">
              <div className="service-icon">🚢</div>
              <h3>Сопровождение грузов</h3>
              <p>
                Юридическая поддержка международных перевозок и логистических
                операций.
              </p>
            </div>

            <div className="service-box" data-aos="fade-up" data-aos-delay="200">
              <div className="service-icon">🌍</div>
              <h3>ВЭД сопровождение</h3>
              <p>
                Поддержка бизнеса при внешнеторговой деятельности и импорте.
              </p>
            </div>

            <div className="service-box" data-aos="fade-up" data-aos-delay="300">
              <div className="service-icon">🛡</div>
              <h3>Таможенные споры</h3>
              <p>
                Представление интересов клиента в спорах и арбитражных
                процессах.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="timeline">
        <div className="container">
          <h2 className="section-title" data-aos="fade-up">
            Как мы работаем
          </h2>

          <div className="timeline-grid">
            <div className="step" data-aos="fade-up">
              <div className="step-number">01</div>
              <h3>Анализ</h3>
              <p>Изучаем ситуацию, риски и документы.</p>
            </div>

            <div className="step" data-aos="fade-up" data-aos-delay="100">
              <div className="step-number">02</div>
              <h3>Стратегия</h3>
              <p>Разрабатываем правовое решение.</p>
            </div>

            <div className="step" data-aos="fade-up" data-aos-delay="200">
              <div className="step-number">03</div>
              <h3>Сопровождение</h3>
              <p>Контролируем процессы и документацию.</p>
            </div>

            <div className="step" data-aos="fade-up" data-aos-delay="300">
              <div className="step-number">04</div>
              <h3>Защита</h3>
              <p>Представляем интересы вашего бизнеса.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="container">
          <div className="cta-box" data-aos="zoom-in">
            <h2>Нужна юридическая поддержка?</h2>
            <p>
              MMX HAMID помогает компаниям безопасно вести международную
              торговлю, сопровождать логистические процессы и минимизировать
              юридические риски.
            </p>
            <button className="btn-primary" type="button">
              Оставить заявку
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="container">
          © 2026 MMX HAMID — International Legal Logistics Support
        </div>
      </footer>
    </div>
  );
};

export default Legal;